import React from 'react';
import { Collapse, Typography, Divider } from 'antd';
const { Title } = Typography;
const { Panel } = Collapse;
import { HelpWrapper } from './style';
import { contactEmail } from '@/lib/locale';
import { useModuleTranslation } from '@/i18n/translation';

const generalP = (str: string) => str.split('<br/>').map((_, index) => <p key={index}>{_}</p>);

const Help: React.FC<{ url: string }> = () => {
  const t = useModuleTranslation('help');
  return (
    <HelpWrapper>
      <h1 className="header">{t.help}</h1>
      <Divider />
      <div className="content">
        <Title level={3}>{t.dashboard}</Title>
        <Collapse accordion>
          <Panel header={t.h1} key="1">
            {generalP(t.p1)}
          </Panel>
          <Panel header={t.h2} key="2">
            <p>{t.p2}</p>
          </Panel>
          <Panel header={t.h3} key="3">
            <p>{t.p3}</p>
          </Panel>
        </Collapse>
        <Title level={3}>{t.transTable}</Title>
        <Collapse accordion>
          <Panel header={t.h4} key="1">
            <p>{t.p4}</p>
          </Panel>
          <Panel header={t.h5} key="2">
            {generalP(t.p5)}
          </Panel>
          <Panel header={t.h6} key="3">
            {generalP(t.p6)}
          </Panel>
          <Panel header={t.h7} key="4">
            <p>{t.p7}</p>
          </Panel>
        </Collapse>
        <Title level={3}>{t.companyInfo}</Title>
        <Collapse accordion>
          <Panel header={t.h8} key="1">
            <p>{t.p8}</p>
          </Panel>
          <Panel header={t.h9} key="2">
            <p>{t.p9}</p>
          </Panel>
        </Collapse>
        <Title level={3}>{t.account}</Title>
        <Collapse accordion>
          <Panel header={t.h10} key="1">
            <p>{t.p10}</p>
          </Panel>
          <Panel header={t.h11} key="2">
            {generalP(t.p11)}
          </Panel>
          <Panel header={t.h12} key="3">
            {generalP(t.p12)}
          </Panel>
          <Panel header={t.h13} key="4">
            <p>{t.p13}</p>
          </Panel>
        </Collapse>
        <Title level={3}>{t.refund}</Title>
        <Collapse accordion>
          <Panel header={t.h15} key="1">
            <p>{t.p15}</p>
          </Panel>
          <Panel header={t.h16} key="2">
            <p>{t.p16}</p>
          </Panel>
          <Panel header={t.h17} key="3">
            {generalP(t.p17)}
          </Panel>
        </Collapse>
        <div className="bottom-tips">
          <p>{t.needHelp}</p>
          <p>
            {t.reach} <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            {t.reach2}
          </p>
        </div>
      </div>
    </HelpWrapper>
  );
};

export default Help;
